/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 *
 * API Title: Offer
 * API Version: 11.8.8
 */
// export enums as arrays so we can use them as options in ui
export const EvePackageVKList = ['none', 'basic', 'premium'];
export const EvePackageTKList = ['none', 'basic'];
export const DiplomaticStatesList = [
    'blue',
    'brown',
    'green',
    'grey',
    'non',
    'orange',
    'red',
    'white',
    'yellow',
];
export const SegmentKeyList = [
    '01.0_AH',
    '02.0_AK',
    '02.1_VK',
    '02.2_TK',
    '04.0_AS',
    '03.0_IU',
    '05.0_U',
    '06.0_VU',
    '07.0_PH',
    '08.0_RS',
    '09.0_LK',
    '10.0_ED',
    '12.0_HH',
    '13.0_EB',
    '14.0_EF',
    '15.0_LW',
    '16.0_GL',
    '17.0_V',
    '18.0_ST',
    '19.0_BW',
    '20.0_FE',
    '21.0_TB',
    '22.0_BU',
    '23.0_MB',
    '24.0_KG',
    '26.0_EG',
    '27.0_TR',
    '28.0_FB',
    '29.0_FF',
    '37.0_FL',
    '40.0_MR',
    '41.0_BM',
    '42.0_MU',
    '43.0_MM',
    '44.0_MG',
    '46.0_PC',
    '96.0_LI',
    '97.0_LH',
    '98.0_LF',
    '99.0_LC',
    '00.0_XX',
];
export const VehicleTypeList = [
    'Motorbike',
    'Motorcycle',
    'Sedan',
    'StationWagon',
    'AKR',
    'AOM',
    'APK',
    'ARB',
    'ASO',
    'AWO',
    'BRD',
    'DIV',
    'DRM',
    'EPK',
    'FWA',
    'FWW',
    'KKR',
    'KOM',
    'KRA',
    'KRF',
    'L6',
    'L7',
    'LKF',
    'LKW',
    'MAE',
    'MDR',
    'MOF',
    'MOT',
    'MP1',
    'MP2',
    'MUF',
    'OMN',
    'PKW',
    'RET',
    'ROL',
    'SAT',
    'SON',
    'STR',
    'TRA',
    'VKF',
    'WML',
    'WMP',
    'ZM1',
    'ZM2',
    'ZMM',
    'ZMP',
    'UNB',
];
export const BonusMalusOriginOptionsList = [
    'none',
    'takeoverPreviousOwner',
    'existingContract',
    'takeoverCustomerInsurer',
];
export const PaymentWayList = [
    'Bankinkasso',
    'Firmenkonto',
    'Zentralinkasso',
    'KKI',
    'unknown',
];
export const GenderList = [
    'divers',
    'female',
    'inter',
    'male',
    'unknown',
];
export const EngineTypeList = [
    'electro',
    'fuelCell',
    'gas',
    'hybrid',
    'ice',
    'otherEngine',
    'noEngine',
    'diesel',
    'petrol',
];
export const UsageTypeList = [
    'ownUse',
    'farmUse',
    'spedUse',
    'factoryTrafficUse',
    'commercialTransportUse',
    'passengerTransportUse',
    'commercialRentalWithoutDriverUse',
    'dangerousGoodsTransportUse',
    'taxiUse',
    'furnitureTransportUse',
    'schoolVehicleUse',
    'circusEquipTransportUse',
    'paidPassengerTransportUse',
    'roadMaintenanceUse',
    'illuminatedRoadsUse',
    'sewerMaintenanceUse',
    'municipalUse',
    'breakdownServiceUse',
    'specialTransportUse',
    'diplomatUse',
    'consulUse',
    'publicServiceUse',
    'postalAdminUse',
    'ambulanceServiceUse',
    'fireBrigadeUse',
    'privateAmbulanceUse',
    'oebbUse',
    'financeManagementUse',
    'taxInvestigationsUse',
    'policeUse',
    'mountainRescueUse',
    'armyUse',
    'presidentTransportUse',
    'stateFunctionariesUse',
];
export const OfferStateList = [
    'calculationState',
    'concept',
    'unbindingOffer',
    'bindingOffer',
    'applicationUnsigned',
    'applicationSigned',
    'applicationCompleted',
    'applicationApprovalPending',
    'applicationApprovalApproved',
    'applicationApprovalDeclined',
    'applicationApprovalApproval',
    'applicationApprovalDeclinedAndCounterOffer',
    'policy',
    'canceled',
    'active',
    'paid',
    'policingPending',
    'notConcluded',
    'correction',
    'alternativeOffer',
];
export const LicensePlateTypeList = [
    'normal',
    'interchangeable',
    'trial',
    'NORM',
    'WKZ',
    'UEB',
    'PRB3',
    'PRB2',
    'OKZ',
    'NZGL',
    'AUSL',
    'ZOLL',
    'SON',
];
export const PreviousDamageStateList = [
    'noPrevDamage',
    'replacementApplication',
    'withPrevDamage',
    'unselectedState',
];
export const PaymentIntervalList = [
    'halfyearly',
    'yearly',
    'monthly',
    'quarterly',
    'unknown',
];
export const ParticipantRoleTypeList = [
    'beneficiary',
    'contactPerson',
    'policyHolder',
    'premiumPayer',
    'transferabilityOwner',
    'intermediary',
    'recommender',
    'producer',
    'non',
    'previousInsurer',
    'prevOwnCloseRelative',
    'prevOwnEmployer',
    'prevOwnLessor',
];
export const DiscountTypeList = [
    'campaingDiscount',
    'cooperationDiscount',
    'customerSpecificDiscount',
    'directDiscount',
    'employeeDiscount',
    'onlineDiscount',
    'otherDiscount',
    'specialDiscount',
    'winterDiscount',
    'couponDiscount',
    'distributionChannelDiscount',
    'minivanDiscount',
    'negativeDiscount',
    'specialLoading',
    'durationDiscount',
];
export const InsuredGoodsVariantList = [
    'variant1000',
    'variant2000',
    'variant3000',
    'noGoods',
];
